<template>
  <el-drawer
    :visible.sync="visible"
    custom-class="process-drawer"
    size="480px"
    :title="$t('fixDutyFine.processRecord')"
    @close="handleClose"
  >
    <div class="drawer-content">
      <!-- 基础信息 Card -->
      <el-card class="info-card" shadow="never">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="info-item">
              <div class="label">{{ $t('fixDutyFine.waybillNumber') }}</div>
              <div class="value text-green">{{ rowData.waybillNumber }}</div>
            </div>
            <div class="info-item mt-10">
              <div class="label">{{ $t('fixDutyFine.region') }}</div>
              <div class="value">{{ rowData.regionName }}</div>
            </div>
            <div class="info-item mt-10">
              <div class="label">{{ $t('fixDutyFine.penaltyType') }}</div>
              <div class="value">{{ rowData.responsibilityTypeName }}</div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="info-item">
              <div class="label">{{ $t('base.billingMonth') }}</div>
              <div class="value">{{ rowData.reconciliationPeriod }}</div>
            </div>
            <div class="info-item mt-10">
              <div class="label">{{ $t('fixDutyFine.site') }}</div>
              <div class="value">{{ rowData.siteName }}</div>
            </div>
            <div class="info-item mt-10">
              <div class="label">{{ $t('fixDutyFine.currentStatus') }}</div>
              <div class="value text-green">{{ rowData.statusName }}</div>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 流转记录时间轴 (后续可改为 v-for 渲染接口数据) -->
      <div class="timeline-section">
        <!-- 节点 1: 系统定责 -->
        <div v-for="(log, index) in rowData.operationLogs" :key="index" class="timeline-node">
          <div class="node-header">
            <span class="node-title">{{ log.operationType }}</span>
            <span class="node-date">{{ log.operationTime }}</span>
          </div>
          <div class="node-body">
            <p>{{ $t('fixDutyFine.operatorLabel') }}{{ log.operatorName }}</p>
            <p>{{ $t('fixDutyFine.operationResultLabel') }}{{ log.operationResult }}</p>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { getDetailInfo } from '@/api/definiteResponsibilityAndPenalty';

export default {
  name: 'ProcessRecordDrawer',
  data() {
    return {
      visible: false, // 自己管理可见性
      loading: false,
      rowData: {} // 当前查看的记录
    };
  },
  methods: {
    // 暴露给父组件的方法：打开抽屉
    async open(record) {
      this.visible = true;
      await this.fetchDetailData(record.id); // 在打开时再请求
    },
    // 请求详情接口 (从子组件迁到父组件，或者由父组件传数据进来)
    async fetchDetailData(id) {
      this.loading = true;
      try {
        const res = await getDetailInfo(id);
        this.rowData = res.data || {};
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-content {
  padding: 0 20px 20px 20px;
}

.info-card {
  margin-bottom: 20px;

  ::v-deep .el-card__body {
    padding: 15px;
  }

  .info-item {
    .label {
      font-size: 12px;
      color: #909399;
      margin-bottom: 6px;
    }

    .value {
      font-size: 14px;
      color: #303133;
      font-weight: 500;

      &.text-green {
        color: #00b050; // 对应UI图的绿色字体
      }
    }
  }

  .mt-10 {
    margin-top: 15px;
  }
}

/* 时间轴节点样式 */
.timeline-section {
  padding-left: 20px;
  border-left: 1px solid #ebeef5;
  margin-left: 10px;
}

.timeline-node {
  position: relative;
  margin-bottom: 30px;

  /* 节点小圆圈 */
  &::before {
    content: '';
    position: absolute;
    left: -26px;
    top: 4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    border: 2px solid #00b050;
  }

  /* 节点1是实心绿点，节点2是空心绿点 */
  &:first-child::before {
    background: #00b050;
  }

  .node-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .node-title {
      font-size: 14px;
      font-weight: bold;
      color: #303133;
    }

    .node-date {
      font-size: 12px;
      color: #909399;
    }
  }

  .node-body {
    font-size: 13px;
    color: #606266;

    p {
      margin: 0 0 6px 0;
    }
  }
}
</style>
